module.exports = __webpack_public_path__ + "img/banner.d62b85bc.jpg";